export default __webpack_public_path__ + "went-wrong.svg";